import { createAsyncThunk } from '@reduxjs/toolkit'
import planService from 'services/plan'

export const getPlans = createAsyncThunk('plan/get', planService.getPlans)
